var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1709 19.4199H17.3101C17.9563 19.4199 18.481 18.8949 18.481 18.2491C18.481 17.6028 17.9563 17.0782 17.3101 17.0782H1.1709C0.524658 17.0782 0 17.6028 0 18.2491C0 18.8949 0.524658 19.4199 1.1709 19.4199ZM1.1709 11.2965H17.3101C17.9563 11.2965 18.481 10.7719 18.481 10.1256C18.481 9.47931 17.9563 8.9548 17.3101 8.9548H1.1709C0.524658 8.9548 0 9.47931 0 10.1256C0 10.7719 0.524658 11.2965 1.1709 11.2965ZM1.1709 3.17355H17.3101C17.9563 3.17355 18.481 2.64902 18.481 2.00269C18.481 1.35638 17.9563 0.831848 17.3101 0.831848H1.1709C0.524658 0.831848 0 1.35638 0 2.00269C0 2.64902 0.524658 3.17355 1.1709 3.17355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.c49be5dff665d807bc72b3d039ba3abe.svg";
export { ForwardRef as ReactComponent };